import { Linear, Sine, TimelineMax } from "gsap";
import * as HLF from "html-living-framework";
import * as Constants from "../Data/Constants";

export class LoadingSpinner extends PIXI.Container {
    private static readonly PIECE_COUNT: number = 8;

    private readonly _pieces: PIXI.Sprite[];
    private _rotateAnim: TimelineMax | undefined;
    private _fadeAnim: TimelineMax | undefined;

    constructor() {
        super();

        this._pieces = new Array<PIXI.Sprite>(LoadingSpinner.PIECE_COUNT);
        for (let i = 0; i < this._pieces.length; ++i) {
            this._pieces[i] = HLF.PixiUtils.makeSprite("spinner-0" + i, Constants.SPRITESHEET_UI);
            this._pieces[i].alpha = 0;
            this.addChild(this._pieces[i]);
        }
        this.visible = false;
    }

    public hide(): TimelineMax {
        const timeline: TimelineMax = new TimelineMax();
        if (this.visible) {
            if (this._fadeAnim !== undefined) {
                this._fadeAnim.kill();
            }
            const fadeDur: number = 0.5;
            const pieceFadeDur: number = 0.15;

            for (let i = 0; i < this._pieces.length; ++i) {
                timeline.to(this._pieces[i], pieceFadeDur, {
                    alpha: 0,
                    ease: Sine.easeInOut,
                }, (i / this._pieces.length) * (fadeDur - pieceFadeDur));
            }
            timeline.call(() => {
                if (this._rotateAnim !== undefined) {
                    this._rotateAnim.kill();
                }
            });
        }
        return timeline;
    }

    public show(): void {
        this.killAnim();
        const rotateDur: number = 1.4;
        const fadeDur: number = 3.0;
        const pieceFadeDur: number = 0.3;
        const fadeWindow: number = fadeDur / 10.0;
        this.visible = true;

        this._rotateAnim = new TimelineMax({
            repeat: -1,
        });
        this._rotateAnim.to(this, rotateDur, {
            rotation: Math.PI * 2.0,
            ease: Linear.easeNone,
        }, 0);

        this._fadeAnim = new TimelineMax({
            repeat: -1,
        });
        for (let i = 0; i < this._pieces.length; ++i) {
            this._fadeAnim.to(this._pieces[i], pieceFadeDur, {
                alpha: 1,
                ease: Sine.easeInOut,
            }, (i / this._pieces.length) * fadeWindow);
            this._fadeAnim.to(this._pieces[i], pieceFadeDur, {
                alpha: 0,
                ease: Sine.easeInOut,
            }, fadeDur - 4 * fadeWindow - pieceFadeDur + ((i / this._pieces.length) * fadeWindow));
            this._fadeAnim.duration(fadeDur);
        }
    }

    public destroy(pOptions?: boolean | PIXI.DestroyOptions | undefined): void {
        this.killAnim();
        super.destroy(pOptions);
    }

    private killAnim(): void {
        if (this._rotateAnim !== undefined) {
            this._rotateAnim.kill();
        }
        if (this._fadeAnim !== undefined) {
            this._fadeAnim.kill();
        }
    }
}
